import { node_url, java_url } from "./url.js";
import {
    getCookie,
    setCookie,
    delCookie,
    isWechar,
    getQuery,
} from "@/utils/utils";
// import myHistory from ''

import store from "@/store";
const qs = require("qs");
if(getQuery("company")) {
    delCookie('merchant-id')
    delCookie('token')
}

const codeMessage = {
    200: "服务器成功返回请求的数据。",
    201: "新建或修改数据成功。",
    202: "一个请求已经进入后台排队（异步任务）。",
    204: "删除数据成功。",
    400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
    401: "用户没有权限（令牌、用户名、密码错误）。",
    403: "用户得到授权，但是访问是被禁止的。",
    404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
    406: "请求的格式不可得。",
    410: "请求的资源被永久删除，且不会再得到的。",
    422: "当创建一个对象时，发生一个验证错误。",
    500: "服务器发生错误，请检查服务器。",
    502: "网关错误。",
    503: "服务不可用，服务器暂时过载或维护。",
    504: "网关超时。",
};

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const errortext = codeMessage[response.status] || response.statusText;
    // notification.error({
    //     message: `请求错误 ${response.status}: ${response.url}`,
    //     description: errortext,
    // });
    const error = new Error(errortext);
    error.name = response.status;
    error.message = response;
    throw error;
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
interface IMyOptionObj {
    method?: string;
    queryParams?: any;
    headers?: any;
    credentials?: any;
    body?: any;
}

export async function requestData(
    obj: {
        url: string;
        options?: object;
        queryParams?: object | string;
        method: string;
        back_url?: boolean | string;
    },
    isCheck?: boolean
) {
    if ((!getCookie("token") || getCookie("token") =='undefined') && !isCheck) {
        let loginRes: any;
        delCookie('merchant-id')
        if (isWechar && getQuery("user_ticket")) {
            loginRes = await requestData(
                {
                    method: "get",
                    url:
                        "/api/v1/user/wechat/redirect/code?user_ticket=" +
                        getQuery("user_ticket") +
                        "&userId=" +
                        getQuery("userId") +
                        "&deviceId=" +
                        getQuery("deviceId") +
                        "&company=" +
                        getQuery("company"),
                    back_url: java_url,
                    options: {
                        headers: {
                            'merchant-id': getQuery("company")
                        }
                    }
                },
                true
            );
            if (loginRes) {
                setCookie("userName", loginRes.data.email, 1);
                setCookie("roleType", loginRes.data.roleType, 1);
                setCookie("token", loginRes.data.token, 1);
               
                const res = await requestData(
                    {
                        method: "post",
                        url:"/api/v1/user/permission/authorized/merchant/list",
                        options: {
                            headers: {
                                authorization: getCookie("token"),
                                'system-id': 3
                            }
                        },
                        back_url: java_url,
                    },
                    true
                );
                if (res && res.code == 0) {
                    if (!getCookie("merchant-id") || !(res.data && res.data.find((item:any) => item.user_id ==getQuery("company")))) {
                        setCookie("merchant-id", getQuery("company") == '101' ? 103 : res.data[0].user_id, 1);
                    } 
                    
                    store.UserData.changeUserData({
                        userName: loginRes.data.email,
                        roleType: loginRes.data.roleType,
                        token: loginRes.data.token,
                        merchantList: res.data
                    });
                }
            }
        } else {
            window.location.replace(`//${window.location.host}/#/loginInne`);
        }
    } 
    const { url, options, queryParams, method, back_url } = obj;
    let requestUrl = `${back_url ? back_url : node_url}${url}`;
    const defaultOptions = {
        credentials: "include",
        withCredentials: true,
        headers: {
            authorization: getCookie("token"),
            // 'system-id': 3
        },
        method,
    };
    if (getCookie("merchant-id")) {
        defaultOptions.headers['merchant-id'] = getCookie("merchant-id")
    }
    const newOptions: IMyOptionObj = { ...defaultOptions, ...options };
    if (method === "post" || method === "put") {
        if (!(queryParams instanceof FormData)) {
            newOptions.headers = {
                Accept: "application/json",
                "Content-Type": "application/json; charset=utf-8",
                ...newOptions.headers,
            };
            newOptions.body = queryParams;
        } else {
            // newOptions.body is FormData
            newOptions.headers = {
                Accept: "application/json",
                ...newOptions.headers,
            };
        }
    } else if (queryParams) {
        requestUrl += "?" + qs.stringify(queryParams);
    }
    console.log("fetch-cache", newOptions);
    return fetch(requestUrl, newOptions)
        .then(checkStatus)
        .then(async (response) => {
            if (method === "delete" || response.status === 204) {
                return Promise.resolve(response.text());
            }
            // console.log('fetch-cache', response);
            const fetchRes = await response.json();
            return fetchRes.result ? Promise.resolve(fetchRes) : fetchRes;
        })
        .catch((err) => {
            const status = err.name;
            if (status === 403 && !isWechar) {
                console.log(err.toString(), "response", err.name);
                delCookie("userName");
                delCookie("roleType");
                delCookie("emall");
                delCookie("token");
                window.localStorage.removeItem('merchantList')
                window.location.replace(
                    `//${window.location.host}/#/loginInne`
                );
                window.location.reload();
                return;
            }
            if (status === 401) {
                delCookie('token')
                delCookie('userName')
                // myHistory.push('/user/login');
                return;
            }
            if (status === 403) {
                // window.location.replace(`//${window.location.host}/#/loginInne`);
                // window.location.reload();
                return;
            }
            if (status <= 504 && status >= 500) {
                // myHistory.push('/exception/500');
                return;
            }
            if (status >= 404 && status < 422) {
                // myHistory.push('/exception/404');
            }
        });
}
